import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Badge from '../../Badge';
import { AVATAR_SIZE_72 } from '../../../../constants/avatar-sizes';
import IdentityAvatarContainer from '../../../../containers/global/identity/IdentityAvatarContainer';
import ShoppingBasketIcon from '../../../icons/ShoppingBasketIcon';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    last_name: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  itemsCount: PropTypes.number,
  isActive: PropTypes.bool,
  className: PropTypes.string,
};

const defaultProps = {
  onSelect: () => {},
};

const IdentitySelectorAvatar = ({
  identity,
  onClick,
  itemsCount,
  isActive,
  className,
}) => {
  const classes = classNames({
    'prepaid-items-identity-selector-avatar': true,
    'is-active': isActive,
    [className]: !!className,
  });

  return (
    <div className="d-flex flex-column align-items-center mr-1">
      <div className={classes}>
        <IdentityAvatarContainer
          identity={identity}
          size={AVATAR_SIZE_72}
          className="identity-selector-avatar-photo"
          onClick={onClick}
          selected={isActive}
          withCheckmark={false}
        />
        {(itemsCount ?? 0) > 0 && (
          <Badge badgeSize="sm" className="text-extra-bold px-1">
            <ShoppingBasketIcon color="white" size={12} />
            &nbsp;{itemsCount}
          </Badge>
        )}
      </div>
      <p className="mb-0 text-xs text-light mt-1">{identity.name}</p>
    </div>
  );
};

IdentitySelectorAvatar.propTypes = propTypes;
IdentitySelectorAvatar.defaultProps = defaultProps;

export default IdentitySelectorAvatar;
